<template>
  <div class="admin-panel-page">
    <h4 class="title mb-4">Tools</h4>
    <v-tabs
      background-color="primary" dark
      height="100"
      slider-size="4"
      slider-color="rgba(255,255,255,.8)"
      class="mb-3">
      <v-tab v-for="(item, index) in toolsTabItems"
          :key="index"
          :to="item.to">
          <div>
            <div class="mb-1">{{ item.text }}</div>
            <div class="caption text-capitalize">{{ item.caption }}</div>
          </div>
      </v-tab>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'tools-list-page',
  data: () => ({}),
  computed: {
    ...mapGetters('routes', ['toolsTabItems']),
  },
};
</script>
